// @ts-ignore
import { createEnum } from '@els/els-react--utils';

export const ResultsPerPage = createEnum({
    EbpcSkillsView: 25,
    UserFavoriteContentView: 25,
});
